import { ReactNode, useEffect, useId, useRef } from "react"
import { IOrgPathResponse } from "../../../types/org"
import "./tooltip.scss"
import { useLazyQuery } from "@apollo/client"
import { GET_ORG_PATH } from "../../../graphql/org-gql"

type ToolTipProps = {
    orgId?: number
    tooltipText?: string
    id?: string
    children: ReactNode
}

const ToolTip = (props: ToolTipProps) => {
    const {orgId, tooltipText, id, children} = props
    const tooltipDiv = useRef<HTMLDivElement>(null)
  
    const gid = useId()
    const _id = id != null && id !== ''? id : gid

    const [getOrgPath, { data }] = useLazyQuery<IOrgPathResponse>(GET_ORG_PATH)
    
    function getPosition(el:any){
        var offsetX = window.scrollX
        var offsetY = window.scrollY
        var rect = el.getBoundingClientRect()

        return {
            x : rect.x + offsetX,
            y : rect.y + offsetY
        }
    }

    function showToolTip(el: any){
        var tooltipContainer = el.closest(".tooltipOMSContainer")
        if(tooltipContainer!=null) {
            var containerPos = getPosition(tooltipContainer)
            var pos = getPosition(el)
            var x = pos.x
            var y = pos.y
            var t = el.closest(".tooltipOMS").querySelector('.tooltiptextOMS')
            if (t != null) {
                var offsetH = t.offsetHeight
                t.style.left = x + "px"
                t.style.top = y - containerPos.y -offsetH - 10 + "px"
                t.style.maxWidth = window.innerWidth * 0.6 + 'px'
                t.classList.add("showToolTip")
                tooltipContainer?.appendChild(t)
            }
        }
    }

    function hideToolTip(el:any){
        var tooltipContainer = el.closest(".tooltipOMSContainer")
        if(tooltipContainer!=null){
            var tooltip = tooltipContainer.querySelector(`#${CSS.escape(el.getAttribute("id"))}_TOOLTIP`)
            if(tooltip!=null){
                tooltip.classList.remove("showToolTip")
                tooltip.style.left = ""
                tooltip.style.top = ""
                el.prepend(tooltip)
            }
        }    
    }
    const onMouseOver = (e: any) => {
        e.stopPropagation()
        var target = e.target 
        if(orgId && !data){
            getOrgPath({
                variables: {id: orgId},
            })            
        }
        else if(!orgId || data){
            showToolTip(target)
        }
                      
      }    
    
    const onMouseOut = (e: any) => {
        e.stopPropagation()
        var target = e.target.closest(".tooltipOMS") 
        hideToolTip(target)    
    }

    const onMouseDown = (e: any) => {
        var target = e.target.closest(".tooltipOMS") 
        hideToolTip(target)    
    }
    
    useEffect(() => {
        var target = tooltipDiv.current!
        if(target?.matches(':hover')) {
            showToolTip(target)            
        }
    }, [data])

    if(!!tooltipText){
        return(
            <div id={_id} className="tooltipOMS" onMouseOver={onMouseOver} onMouseDown={onMouseDown} onMouseOut={onMouseOut} ref={tooltipDiv}>
                <span id={_id+"_TOOLTIP"} className="tooltiptextOMS" aria-live={"assertive"} role="alert" style={{pointerEvents: "none"}}>
                    {tooltipText}
                </span>
                {children}
            </div>
        )
    }
    else if(orgId){
        return (
            <div id={_id} className="tooltipOMS" onMouseOver={onMouseOver} onMouseDown={onMouseDown} onMouseOut={onMouseOut} ref={tooltipDiv}>
                <span id={_id+"_TOOLTIP"} className="tooltiptextOMS" aria-live={"assertive"} role="alert" style={{pointerEvents: "none"}}>
                    {data?.orgPath?.map((element, index) => {                        
                        return <div key={index} style={{marginLeft: `${(index) * 15}px`, display: 'flex'}}>
                                    <div className={`fa ${index === data?.orgPath.length - 1 ? "fa-caret-right" : "fa-caret-down"}`} style={{flex: '0 0 15px', paddingTop: '3px'}} /> 
                                    <div style={{flex: '1'}}>{element}</div>
                                </div>                        
                    })
                    }
                </span>
                {children}
            </div>            
        )
    }
    else{
        return(<>{children}</>)
    }
}

export default ToolTip
